import styled from 'styled-components';

export const NavigationRow = styled.div`
  display: flex;
  justify-content: space-between;
`;
